// extracted by mini-css-extract-plugin
module.exports = {"LogoutBtn":"LogoutBtn-module--LogoutBtn--2TX0Q"};